import React from "react";
import styled from "@emotion/styled";

import Button from "@components/Button";
import JoinRemaxForm from "./form";
import { useTranslations } from "next-intl";

function JoinRemax() {
  const translation = useTranslations("join");
  const translationJoinUs = useTranslations("join.joinUs");
  return (
    <Wrapper>
      <BackgroundImage>
        {/* <Image
          src=""
          alt="Bienvenido a tu nueva casa Remax República Dominicana"
        /> */}
      </BackgroundImage>
      <CoverDetails>
        <CoverContainer>
          <CoverContent>
            <CoverTitle>{translation("title")}</CoverTitle>
            <CoverText>{translationJoinUs("description")}</CoverText>
            <CoverText>{translationJoinUs("control")}</CoverText>
            {/* <CoverText>{translationJoinUs("remaxBranch")}</CoverText> */}
            {/* <JoinRemaxForm> */}
            <CoverButton
              component="a"
              href="https://reclutamiento.remaxrd.com/#Formulario"
              target="_blank"
              rel="noopener noreferrer"
            >
              {translationJoinUs("joinFamily")}
            </CoverButton>
            {/* </JoinRemaxForm> */}
          </CoverContent>
        </CoverContainer>
      </CoverDetails>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  position: relative;
`;

const BackgroundImage = styled.div`
  width: 100%;
  height: 100dvh;
  background-image: url("/images/v2/pic/image-04.webp");
  background-size: cover;
  background-position: center 25%;
  background-repeat: no-repeat;
  background-color: var(--color-brand-bg-secondary);

  @media screen and (max-width: 991px) {
    height: 50dvh;
  }

  @media screen and (max-width: 500px) {
    height: 250px;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: ;
`;

const CoverDetails = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;

  @media screen and (max-width: 991px) {
    position: static;
    background-color: var(--color-brand-blue-main);
  }
`;

const CoverContainer = styled.div`
  height: 100%;
  position: relative;
`;

const CoverContent = styled.div`
  position: absolute;
  left: 5dvw;
  top: 20dvh;
  width: 563px;
  padding: 44px 57px 50px;
  background-color: var(--color-brand-blue-main);
  border-radius: 15px;

  @media screen and (max-width: 991px) {
    position: static;
    width: 100%;
  }

  @media screen and (max-width: 767px) {
    padding: 40px 20px;
    * {
      text-align: center;
    }
  }
`;

const CoverTitle = styled.h1`
  font-size: 1.938rem;
  font-weight: 500;
  color: #fff;
  margin-bottom: 33px;

  @media screen and (max-width: 480px) {
    // white-space: nowrap;
    font-size: 1.638rem;

    // line-height: 10px;
  }
`;

const CoverText = styled.p`
  color: #fff;
  font-size: 15.6px;
  font-weight: 400;
  margin-bottom: 20px;
  line-height: 29px;
`;

const CoverButton = styled(Button)`
  width: 100%;
  max-width: 265px;
  position: absolute;
  bottom: -20px;
  margin: 0 auto;
  left: 50%;
  transform: translateX(-50%);
  text-decoration: none;
  background-color: var(--color-brand-red-main);
  border-radius: 15px !important;
`;

export default JoinRemax;
